<script setup lang="ts">
import type { Property, PropertyOnCard } from '@@/shared/property/types';
import type { PropertyOnList } from '@@/shared/property/api-types';

defineProps<{
  property: Property | PropertyOnList | PropertyOnCard
}>();
</script>

<template>
  <ul class="empty:hidden">
    <IadTag
      v-for="tag in property.tags"
      :key="tag"
      :text="$t(`property.tags.${tag}`)"
      tag="li"
    />
  </ul>
</template>
